import { Typography } from "@povio/ui";
import clsx from "clsx";

import LossdogFallbackImage from "@/assets/images/home/EmptyState2.png";
import ProfileProjectMediaItem from "@/components/home/sections/components/ProfileProjectMediaItem";
import { DemoClickWrapper } from "@/components/shared/demo/DemoClickWrapper";
import type { CommonModels } from "@/data/common/common.models";

interface IProps {
  project: CommonModels.ProjectWithMediaDto;
  isPublic: boolean;
  onProjectClick: (project: CommonModels.ProjectWithMediaDto) => void;
}

const ProfileProjectCard = ({ project, isPublic, onProjectClick }: IProps) => {
  const handleEditProject = () => {
    if (!isPublic) {
      onProjectClick(project);
    }
  };

  return (
    <DemoClickWrapper>
      <div
        className={clsx(
          "print-project-container group flex h-full w-full min-w-[104px] t:min-w-[185px] max-w-[104px] t:max-w-[185px] shrink-0 snap-start flex-col gap-1 p-0-5",
          {
            "cursor-pointer": !isPublic,
          },
        )}
        data-testid="project-image-container"
        onClick={handleEditProject}
      >
        <div className="group relative flex aspect-square t:aspect-video h-full w-full items-center justify-center overflow-hidden rounded-xl t:rounded-lg">
          <ProfileProjectMediaItem
            project={project}
            placeholderImage={LossdogFallbackImage.src}
          />
        </div>
        {project.title && (
          <Typography
            size="title-5"
            className="truncate px-1 pb-0-5"
          >
            {project.title}
          </Typography>
        )}
      </div>
    </DemoClickWrapper>
  );
};

export default ProfileProjectCard;
